





















































































import { createComponent, ref, onMounted, computed, watch, SetupContext } from '@vue/composition-api'

import { sliceUploader } from '@oppo/slice-uploader/src/compositionApi/sliceUploder'
import { TableFile, IFile, Handlers } from '@oppo/slice-uploader/src/types'
import { Message } from 'element-ui'
import { getFileIcon } from '@/helpers/common'
import { getFilesDetail } from '@/service/public'
/*
  事件
  on-file-save-success // 存文件成功的回调函数 （res, file）
  on-file-save-error   // 存文件失败的回调函数 （res, file）
  on-file-send-error   // 上传文件post请求失败的回调 （error, file）
  on-file-check-error  // 检查文件get请求失败的回调 （error, file[源文件信息]）
  on-file-pause        // 点击暂停的处理函数 （file）
  on-file-resume       // 点击恢复和重试的处理函数 （file）
  on-file-remove       // 点击删除的处理函数 （file）
*/

export default createComponent({
    props: {
        accept: {
            type: String,
            default: '',
        },
        isShowButton: {
            type: Boolean,
            default: false,
        },
        isDrop: {
            type: Boolean,
            default: false,
        },
        chunkSize: {
            type: Number,
            default: 5 * 1024 * 1024,
        },
        dirId: {
            type: String,
            default: '0',
        },
        maxRequst: {
            type: Number,
            default: 4,
        },
        checkFileUrl: {
            type: String,
            default: '/api/upload',
        },
        sendFileUrl: {
            type: String,
            default: '/api/upload',
        },
        saveFileUrl: {
            type: String,
            default: '/api/saveUploadFile',
        },
        preUploadCheckFile: {
            type: Function,
            default: res => {
                return true
            },
        },
        checkFileUploadedChunks: {
            type: Function,
            default: res => {
                return []
            },
        },
        shouldAddedFilesUpload: {
            type: Function,
            default: files => {
                return files
            },
        },
        sameFileCheck: {
            type: Boolean,
            default: false,
        },
        sameFileNoSave: {
            type: Boolean,
            default: false,
        },
        checkSameFile: {
            type: Function,
            default: res => {
                return new Promise((resolve, reject) => {
                    resolve({ checkType: 1 })
                })
            },
        },

        handleSameFile: {
            type: Function,
            default: (res, fileName) => {
                // 文件比较结果处理
                return new Promise((resolve, reject) => {
                    resolve({ saveFile: true })
                })
            },
        },
        retryCount: {
            type: Number,
            default: 8,
        },
        retryTime: {
            type: Number,
            default: 30,
        },
        retryIntervalTime: {
            type: Number,
            default: 2,
        },
        formatCheckFileHttpParam: {
            type: Function,
            default: params => {
                return params
            },
        },
        formatSendFileHttpParam: {
            type: Function,
            default: (params, file) => {
                return params
            },
        },
        formatSaveFileHttpParam: {
            type: Function,
            default: (params, file) => {
                return params
            },
        },
    },
    setup(props, setupContext: SetupContext) {
        const Handlers: Handlers = {
            onFileSaveSuccess: (res: any, file: TableFile) => {
                setupContext.emit('on-file-save-success', res.data, file)
                // Message.success("上传成功");
            },
            onFileSaveError: (res: any, file: TableFile) => {
                setupContext.emit('on-file-save-error', res.data, file)
            },
            onFileCheckError: (error: any, file: IFile) => {
                setupContext.emit('on-file-check-error', error, file)
            },
            onFileStateSuccess: (file: TableFile) => {
                setupContext.emit('on-file-state-success', file)
                Message.success('上传成功')
            },
            onFileMd5Error: () => {
                // console.log('nmmmd5 errro')
                setupContext.emit('on-file-md5-error')
                Message.error('计算文件MD5失败')
            },
        }
        const useSliceUploader = sliceUploader(props, Handlers)
        const uploadList = computed(() => {
            // const newVal = useSliceUploader.tableList.value.filter(it => {
            //     // return it.status !== "finished";
            //     return true
            // })
            const newVal = useSliceUploader.tableList.value
            return newVal
        })
        const dirNames = ref<{ [key: string]: string }>({})
        const getDirNames = async () => {
            const ids = uploadList.value.map(item => item.dirId) as string[]
            const res = await getFilesDetail(ids)
            if (res.code === 0) {
                res.data.forEach(item => {
                    dirNames.value[item.id] = item.name
                })
            }
        }
        //props
        watch(
            () => props.dirId,
            val => {
                useSliceUploader.updateProps({
                    dirId: val,
                })
            }
        )

        const len = computed(() => {
            return uploadList.value.length
        })
        watch(
            () => len.value,
            (newVal, oldVal) => {
                setupContext.emit('on-filelist-length-change', newVal)
                if (newVal) {
                    getDirNames()
                }
            }
        )

        return {
            ...useSliceUploader,
            dirNames,
            uploadList,
            len,
            getFileIcon,
        }
    },
})
function getProgressStatus(file: TableFile) {
    if (file.status === 'error') {
        return 'exception'
    }
    if (file.status === 'finished') {
        return 'success'
    }
    return ''
}
